import { request } from 'umi';
import { InquiryType, IRecordFinishedParams, OnlineInquiryScheduleParam, OnlineInquirySetting } from './data';

// /online-inquiry/mng/record-finished 咨询历史记录（服务端）
export async function getRecordFinished(params: IRecordFinishedParams) {
  return request('/hm/online-inquiry/mng/record-finished', {
    params
  })
}

// /online-inquiry/mng/servers-department/list 科室列表
export async function getServersDepartmentList() {
  return request('/hm/online-inquiry/mng/servers-department/list');
}

// /user/manage/search  查服务人员的接口
export async function getUserMangeSearch() {
  return request('/core/user/manage/search/team');
}

///online-inquiry/mng/servers/inquiry-detail 服务端获取咨询详情（服务端）
export async function getInquiryDetail(params: {inquiryId : string}) {
  return request('/hm/online-inquiry/mng/servers/inquiry-detail', {
    params
  });
}

export async function getServersEndpoint(params: {inquiryId : string, type: InquiryType}) {
  return request('/hm/online-inquiry/mng/servers/endpoint', {
    params
  });
}

// /online-inquiry/mng/servers/endpoint/info   服务端获取终端用户的信息: 头像名称等（服务端）
export async function getEndPiontInfo(params: {eid: string, imId: string, type: InquiryType}) {
  return request('/hm/online-inquiry/mng/servers/endpoint/info', {
    params
  });
}

// /online-inquiry/mng/servers/history 服务端查看消息记录（服务端）
export async function getServersHistory(params: {eid: string, imId: string, cursor?: string, size?:number}) {
  return request('/hm/online-inquiry/mng/servers/history', {
    params
  });
}

export async function getInquirySetting(params: { type: InquiryType, module: InquiryType }) {
  return request('/hm/online-inquiry/mng/setting', {
    params
  })
}

export async function saveInquirySetting(params: Partial<OnlineInquirySetting>) {
  return request('/hm/online-inquiry/mng/setting/save', {
    method: 'POST',
    data: params
  })
}

export async function getInquiryScheduleList(params: { targetDate?: string; type?: InquiryType, module?: InquiryType }) {
  return request('/hm/online-inquiry/mng/schedule/list', {
    params
  })
}

export async function saveInquirySchedule(params: Partial<OnlineInquiryScheduleParam>) {
  return request('/hm/online-inquiry/mng/schedule/saveBatch', {
    method: 'POST',
    data: params
  })
}
